// extracted by mini-css-extract-plugin
export default {"pdfButton":"styles_pdfButton__s86VI"};